module.exports = __webpack_public_path__ + "64e30c076079d3114a2f3874b6a9c5d2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/burrito-s.png
// module id = 2494
// module chunks = 0